export default function Burger() {
  return (
    <path
      fill="currentColor"
      d="M46.286 37.6c.946 0 1.714.76 1.714 1.7 0 .938-.768 1.7-1.714 1.7H1.714C.767 41 0 40.238 0 39.3c0-.94.767-1.7 1.714-1.7h44.572zm0-15.3c.946 0 1.714.76 1.714 1.7s-.768 1.7-1.714 1.7H1.714C.767 25.7 0 24.94 0 24s.767-1.7 1.714-1.7h44.572zm0-15.3C47.232 7 48 7.76 48 8.7s-.768 1.7-1.714 1.7H1.714C.767 10.4 0 9.64 0 8.7S.767 7 1.714 7h44.572z"
    />
  )
}
